import classNames from 'clsx';
import React, { memo, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getPublicUrl } from 'reactApp/appHelpers/appHelpers';
import { AccessStatus } from 'reactApp/components/SharingNewBiz/SharingNew.types';
import { getItemById, isMountedOrSharedFolder } from 'reactApp/modules/storage/storage.selectors';
import { RootState } from 'reactApp/store';
import { AccessRights } from 'reactApp/types/Tree';
import { sendGa } from 'reactApp/utils/ga';

import styles from './EmptyFolder.css';
import { useEmptyFolderContent } from './EmptyFolder.hooks';
import { EItemType, gaSuffix, IProps } from './EmptyFolder.types';

export const EmptyFolder = memo(function EmptyFolder(props: IProps) {
    const { folder } = props;
    // eslint-disable @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const isAlbum = folder?.type === 'album';
    const publicUrl = getPublicUrl(folder);
    const emptyFolderContent = useEmptyFolderContent(folder?.id || '', publicUrl, isAlbum);
    // @ts-ignore
    const { isReadOnly, parent, weblinkAccessRights, weblinkDownloadable } = folder;
    const isMounted = useSelector((state: RootState) => isMountedOrSharedFolder(state, folder)).isMounted;
    // @ts-ignore
    const isParentReadOnly = useSelector((state: RootState) => getItemById(state, parent))?.isReadOnly;
    const isPublicReadWrite = weblinkAccessRights === AccessRights.rw;
    const isCascadedReadOnly = isReadOnly || (isMounted && isParentReadOnly);
    const uploadOrReadOnlyStatus = isPublicReadWrite && !isCascadedReadOnly ? AccessStatus.Upload : AccessStatus.ReadOnly;
    const accessRights = weblinkDownloadable ? AccessStatus.Download : uploadOrReadOnlyStatus;
    // eslint-enable @typescript-eslint/ban-ts-comment

    const handleCm = useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
    }, []);

    useEffect(() => sendGa(gaSuffix, 'show'), []);

    return (
        <div className={styles.root} onContextMenu={handleCm}>
            {Object.entries(emptyFolderContent).map((data) => {
                const [type, itemData] = data;
                const item = itemData(accessRights);
                const shared = Boolean(type === EItemType.COSHARING && publicUrl);

                return (
                    <section
                        key={type}
                        role="presentation"
                        onClick={item.onClick}
                        className={classNames({
                            [styles.item]: true,
                            [styles[`item_type_${type}`]]: Boolean(type),
                            [styles.item_shared]: shared,
                        })}
                    >
                        <div className={styles.actionIcon}>{item.Icon}</div>
                        <h1 className={styles.header}>{item.title}</h1>
                        <p className={styles.annotation}>{item.annotation}</p>
                        {item.additionLinks}
                    </section>
                );
            })}
        </div>
    );
});
